import { render, staticRenderFns } from "./Form6Layout.vue?vue&type=template&id=45f6b4b7&scoped=true"
import script from "./Form6Layout.vue?vue&type=script&lang=ts"
export * from "./Form6Layout.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=45f6b4b7&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f6b4b7",
  null
  
)

export default component.exports